<template>
  <div>
    <label class="el-form-item__label"
           :style="{width: proxyLabelWidth}"
    >{{label}}</label>
    <div class="el-form-item__content"
         :style="{'margin-left': proxyLabelWidth}">
      <slot>
        <gj-text width="100%">{{content}}</gj-text>
      </slot>
    </div>
  </div>
</template>

<script>
  import emitter from '../../minxins/emitter'
  export default {
    name: "gj-desc",
    mixins: [emitter],
    props: {
      label: {
        type: String,
        default: null
      },
      labelWidth: {
        type: String,
        default: null
      },
      content: {
        type: String,
        default: null
      },
      gutterBottom: {
        type: String,
        default: null
      }
    },
    data() {
      return {
        proxyLabelWidth: null,
      }
    },
    created() {
      this.proxyLabelWidth = this.labelWidth;
    },
    mounted() {
      this.dispatch('gj-desc-group', 'gj.descGroup.addDesc', [this]);
    },
  }
</script>

<style scoped>
  .el-form-item {
    margin-bottom: 0;
  }
</style>
